import { model as i18n } from '!/i18n'
import { register } from '!/repository'
import { combine, type Store } from 'effector'
import { model as genericModel } from '~/features/payment/generic'

export const $purchaseUnavailableError: Store<string> = combine(
  i18n.$t,
  ({ t }) => t('purchases_unavailable_error')
)
export const $tryAgainOrContactManager: Store<string> = combine(
  i18n.$t,
  ({ t }) => t('try_again_or_contact_manager')
)
export const $okButton: Store<string> = combine(i18n.$t, ({ t }) => t('ok'))

register(genericModel.$noOptionsPopupIsOpened, '$noOptionsPopupIsOpened')

register(genericModel.closeNoOptionsPopup, 'closeNoOptionsPopup')
register($purchaseUnavailableError, '$purchaseUnavailableError')
register($tryAgainOrContactManager, '$tryAgainOrContactManager')
register($okButton, '$okButton')
